module.exports = __webpack_public_path__ + "img/score.922d0447.svg";